<template>
    <v-container>
        <v-row
            align="center"
            justify="center"
        >
            <v-col cols="8">
                <v-card outlined class="mx-auto" max-width="600">
                    <v-card-subtitle>
                        Agregar Operacion
                    </v-card-subtitle>
                    <v-card-text>
                        <v-row>
                            <v-col
                                cols="12"
                                md="4"
                            >
                                <v-dialog
                                    ref="dialog"
                                    v-model="modal"
                                    :return-value.sync="date"
                                    persistent
                                    width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="date"
                                            label="Fecha de operacion"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            :disabled="selectedDate"
                                            v-bind="attrs"
                                            v-on="on"
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="date"
                                        locale="es-us"
                                        @input="$refs.dialog.save(date)"
                                    >
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                            <v-col
                                cols="12"
                                md="8"
                            >
                               <v-btn
                                    depressed
                                    :color="colorBotton"
                                    @click="toggleSelect"
                                >
                                    {{textButton}}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="8" v-if="selectedDate">
                <v-card outlined class="mx-auto" max-width="600">
                    <v-card-subtitle>
                        Agregar actividades dia {{date}}
                    </v-card-subtitle>
                    <v-card-text>
                        <v-row>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-text-field
                                    label="Jefe de Turno"
                                    name="leader"
                                    type="text"
                                    outlined
                                    dense
                                    v-model="leader"
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-text-field
                                    label="Turno"
                                    name="workshift"
                                    type="text"
                                    outlined
                                    dense
                                    v-model="workshift"
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-dialog
                                    ref="dialogStart"
                                    v-model="startModal"
                                    :return-value.sync="startTime"
                                    persistent
                                    width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="startTime"
                                            label="Inicio actividad"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </template>
                                    <v-time-picker
                                        v-if="startModal"
                                        v-model="startTime"
                                        full-width
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="startModal = false"
                                        >
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="$refs.dialogStart.save(startTime)"
                                        >
                                            OK
                                        </v-btn>
                                    </v-time-picker>
                                </v-dialog>
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-dialog
                                    ref="dialogEnd"
                                    v-model="endModal"
                                    :return-value.sync="endTime"
                                    persistent
                                    width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="endTime"
                                            label="Fin actividad"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </template>
                                    <v-time-picker
                                        v-if="endModal"
                                        v-model="endTime"
                                        full-width
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="endModal = false"
                                        >
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="$refs.dialogEnd.save(endTime)"
                                        >
                                            OK
                                        </v-btn>
                                    </v-time-picker>
                                </v-dialog>
                            </v-col>
                            <v-col cols="12">
                                <v-combobox
                                    v-model="select"
                                    :items="items"
                                    label="Seleccionar actividad"
                                    small-chips
                                    multiple
                                    outlined
                                    dense
                                ></v-combobox>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-btn
                                    text
                                    color="primary"
                                     @click="addActivity"
                                >
                                    Agregar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="8" v-if="dayActivity.length > 0">
                <v-card outlined class="mx-auto" max-width="1000">
                    <v-card-subtitle>
                        Operaciones
                    </v-card-subtitle>
                    <v-card-text>
                        <v-simple-table
                            fixed-header
                            height="300px"
                        >
                            <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Jefe
                                    </th>
                                    <th class="text-left">
                                        Turno
                                    </th>
                                    <th class="text-left">
                                        Hora
                                    </th>
                                    <th class="text-left">
                                        Actividades
                                    </th>
                                    <th class="text-left">
                                        
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr
                                    v-for="(item, index) in dayActivity"
                                    :key="index"
                                >
                                    <td>{{ item.leader }}</td>
                                    <td>{{ item.workshift }}</td>
                                    <td>{{ item.start }} - {{ item.end }}</td>
                                    
                                    <td>
                                        <v-chip
                                            v-for="activity in item.activity"
                                            :key="activity.value"
                                            class="ma-2"
                                            :color="activity.color"
                                            x-small
                                        >
                                            {{activity.text}}
                                        </v-chip> 
                                    </td>
                                    <td>
                                        <v-btn
                                            fab
                                            text
                                            x-small
                                            color="primary"
                                            @click="editActivity(item, index)"
                                        >
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                        <v-btn
                                            fab
                                            x-small
                                            text
                                            color="error"
                                            @click="removeActivity(item, index)"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
	import moment from 'moment'

	export default {
        name: 'Users',
        

		data: () => ({
            modal: false,
            date: moment().format("YYYY-MM-DD"),
            selectedDate: false,
            leader: null,
            workshift: null,
            startTime: null,
            endTime: null,
            startModal: false,
            endModal: false,
            select: [],
            items: [
                {
                    value: 'collation',
                    text: 'colación',
                    color: '#FF9F90'
                },
                {
                    value: 'line',
                    text: 'línea',
                    color: '#ffc000'
                },
                {
                    value: 'planter',
                    text: 'planadora',
                    color: '#0070c0'
                },
                {
                    value: 'staker',
                    text: 'staker',
                    color: '#cc00cc'
                },
                {
                    value: 'rustic',
                    text: 'rustico',
                    color: '#ffff00'
                },
                {
                    value: 'detention',
                    text: 'detención',
                    color: '#ffe598'
                }
            ],
            dayActivity: [],
            editMode: false
		}),
		
		methods: {
            toggleSelect () {
                this.selectedDate = !this.selectedDate

                if (this.selectedDate) {
                    const payload = { date: this.date }
                    this.$store.dispatch('pullOperation', payload)
                } else {
                    this.dayActivity = []
                }
            },

            addActivity () {
                const payload = {
                    leader: this.leader,
                    workshift: this.workshift,
                    start: this.startTime,
                    end: this.endTime,
                    activity: this.select,
                    date: this.date
                }

                this.dayActivity.push(payload)
                this.$store.dispatch('pushOperation', payload)
            },

            editActivity (activity, index) {
                this.leader = activity.leader
                this.workshift = activity.workshift
                this.startTime = activity.start
                this.endTime = activity.end
                this.select = activity.activity

                this.dayActivity.splice(index, 1)

                const payload = {
                    id: activity._id
                }
                
                this.$store.dispatch('removeOperation', payload)
            },

            removeActivity (activity, index) {
                this.dayActivity.splice(index, 1)
                
                const payload = {
                    id: activity._id
                }

                this.$store.dispatch('removeOperation', payload)
            },

            getItems (value) {
                return this.items.find( e => {
                    return e.value === value
                })
            }
		},

		computed: {
            textButton () {
                return this.selectedDate ? 'Cambiar' : 'Seleccionar'
            },

            colorBotton () {
                return this.selectedDate ? '' : 'primary'
            },

            dateOperation () {
                return this.$store.getters.operation
            },

            idOperation () {
                return this.$store.getters.idOperation
            }
		},

        watch : {
            startTime (val) {
                if (this.endTime === null) {
                    this.endTime = moment(`${this.date}T${val}`).add(10, 'minutes').format('HH:mm')
                    return
                }

                const startDate = moment(`${this.date}T${val}`)
                const endDate = moment(`${this.date}T${this.endTime}`).format()

                if (startDate.isAfter(endDate)) {
                    const diff = startDate.diff(endDate, 'minutes')
                    this.startTime = startDate.subtract(diff + 10, 'minutes').format('HH:mm')
                }
            },

            endTime (val) {
                if (this.startTime === null) {
                    this.startTime = moment(`${this.date}T${val}`).subtract(10, 'minutes').format('HH:mm')
                    return
                }

                const endDate = moment(`${this.date}T${val}`)
                const startDate = moment(`${this.date}T${this.startTime}`).format()

                if (endDate.isBefore(startDate)) {
                    const diff = endDate.diff(startDate, 'minutes')
                    this.endTime = endDate.add(diff + 10, 'minutes').format('HH:mm')
                }
            },

            dateOperation (val) {
                this.dayActivity = []

                val.forEach(e => {
                    let activity = []
                    e.activity.forEach( ee => {
                        activity.push(this.getItems(ee))
                    })

                    e.activity = activity
                    this.dayActivity.push(e)
                })
            },

            idOperation (val) {
                const last =  this.dayActivity.length - 1
                this.dayActivity[last]._id = val
            }
        },

		filters : {

		},

		created () {
			moment.locale('es-us')
		}

	}
</script>
